import { forwardRef, ForwardedRef, useState } from 'react'
import { CustomMoneyIcon } from './CustomMoneyIcon'
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string
  inputId: string
  error?: {
    message?: string // Allow message to be undefined
  },
  required?: boolean,
  placeholder?: string
  money?: boolean,
  companySearch?: boolean, 
}

const Input = forwardRef<HTMLInputElement, InputProps>(({ label, inputId, error, required = false, placeholder, money = false, companySearch = false, type, defaultValue, ...props }, ref: ForwardedRef<HTMLInputElement>) => {
  const [isEmpty, setIsEmpty] = useState(!defaultValue);

  return (
    <div>
      <label
        htmlFor={inputId}
        className={`
          ${error ? 'text-[var(--theme-danger)]' : 'text-[var(--theme-text)]'} block pl-2.5 text-sm/6 font-[var(--font-weight-bold)] h-6 leading-4 text-pretty ${required ? 'after:ml-1.5 after:content-["*"]' : ''}
        `}
      >
        {label}
      </label>
      <div className='mt-2.5 grid grid-cols-1 relative'>
        {money && <div className="shrink-0 text-base text-[var(--theme-text)] select-none sm:text-sm/6 h-full flex items-center w-6 justify-center absolute left-1 top-0 pointer-events-none"><CustomMoneyIcon className='size-6' /></div>}
        <input
          ref={ref} 
          {...props}
          type={type}
          defaultValue={defaultValue}
          id={inputId}
          placeholder={placeholder}
          onInput={(e) => setIsEmpty(!(e.target as HTMLInputElement).value)}
          className={`
            transition duration-500 appearance-none
            col-start-1 row-start-1 block w-full outline outline-1 outline-[var(--input-border)] rounded-md bg-white py-[11px] text-base]
            ${error ? 'outline-[var(--theme-danger)] focus:outline-[var(--theme-danger)]' : 'focus:outline-[var(--input-text)]'}
            placeholder:text-[var(--input-placeholder)] focus:outline-1 sm:text-lg
            ${money ? 'pl-8 pr-3' : 'px-3'}
            ${type === 'date' && isEmpty ? 'text-[var(--input-placeholder)] focus:text-[var(--input-text)]' : 'text-[var(--input-text)]'}
            ${companySearch ? 'pl-3 pr-10 truncate' : ''}
          `}
        />
      </div>
      {error && error.message && <p className='p-0.5 text-md text-[var(--theme-danger)]'>{error.message}</p>}
    </div>
  );
})

export default Input
